import React, { Component } from 'react';
import { Modal, Button, Tooltip, OverlayTrigger, FormLabel } from 'react-bootstrap';
import {
    saveOrderEditData,
    getOrderDataById,
    orderEasyUpdate,
    generateResultPDF,
    checkMedicationReflux
} from '../../../services/clinicPortalServices/orderEditService';
import { fetchPhysicians } from '../../../services/clinicPortalServices/physicianServices';
import {
    createRequisitionPDF,
    generateUniqueKey,
    revertCancelRequisition
} from '../../../services/clinicPortalServices/requisitionService';
import moment from 'moment';
import { arraysEqual, getUserDetails, getUserFullName, getUserRole, isUsingInternalSample } from '../../../services/common/util';
import { approveReport, markPreliminary, addCallbackComment, addCorrection } from '../../../services/clinicPortalServices/orderSearchService';
import ToxReviewPopup from '../toxReview/ToxReviewPopup';
import { FormControl, Checkbox, Select, InputLabel, MenuItem, TextField, Autocomplete, Box, Chip } from '@mui/material';
import Swal from 'sweetalert2';
import toastr from 'toastr';
import OrderViewPopup, { SubOrderDrawer } from '../orders/clinicOrderGrid/orderViewPopup';
import { ModalStyled } from '../../../theme/customizedStyleComponents';
import OrderStatusPopup from '../toxicologyAllTests/shared/orderStatusPopup';
import CallbackCommentPopup from '../toxicologyAllTests/shared/CallbackCommentPopup';
import { previewReport } from '../../../services/clinicPortalServices/reportSettingsService';
import { serviceConstants } from '../../../services/common/constants';
import { getUserAuthToken } from '../../../services/common/util';
import AddTestToRequisition from './addTestToRequisition';
import CorrectionInfoPopup from '../toxicologyAllTests/shared/CorrectionInfoPopup';
import CorrectionHistoryPopup from '../toxicologyAllTests/shared/CorrectionHistoryPopup';
import UploadFileModel from './UploadFileModel';

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showStatusPopup: false,
            showRevertCancelPopup: false,
            orderId: props.data._id,
            gender: 'U',
            dob: '',
            mrn: '',
            provider: '',
            facilitySource: '',
            facilityDetails: {},
            receivedDate: '',
            description: '',
            specimenType: '',
            diagnosisCode: [],
            sample: '',
            externalSampleId: '',
            result: '',
            collectedDate: '',
            collectorName: '',
            requisition: '',
            code: '',
            codeType: '',
            symptoms: [],
            patientDetails: null,
            patientName: '',
            email: '',
            mobile: '',
            providerDetails: null,
            providerFirstName: '',
            providerLastName: '',
            providerNPI: '',
            facilityId: '',
            insuranceDetails: null,
            errors: [],
            saving: false,
            showOrderViewPopup: false,
            showDrawer: false,
            testDetails: {},
            showAddTestToRequisitionPopup: false,
            requisitionPDFPath: '',
            orderType: '',
            showCorrectionInfoPopup: false,
            showCorrectionHistoryPopup: false,
            correctionHistory: props.data.correction_history || [],
            medications: [],
            isModalOpen: false,
            requisitionPdfPaths:[]
        };

        this.userName = '';
        if (getUserDetails()) {
            this.userName = getUserFullName();
        }

        this.loadOrderDetails();
    }

    hasError = (key) => {
        return this.state.errors.indexOf(key) !== -1;
    };

    loadOrderDetails = (showOrderViewPopup = false) => {
        getOrderDataById(this.state.orderId).then((response) => {
            let orderDetails = response.data;
            // Update correction history from the latest order data
            if (orderDetails.correction_history) {
                this.setState({ correctionHistory: orderDetails.correction_history });
            }
            this.setState(
                {
                    patientName:
                        orderDetails && orderDetails.patient_id
                            ? orderDetails.patient_id.first_name + ' ' + orderDetails.patient_id.last_name
                            : '',
                    patientDetails: orderDetails && orderDetails.patient_id ? orderDetails.patient_id : {},
                    mrn: orderDetails && orderDetails.patient_id ? orderDetails.patient_id.mrn : '',
                    dob: orderDetails && orderDetails.patient_id ? orderDetails.patient_id.date_of_birth : '',
                    gender: orderDetails && orderDetails.patient_id ? orderDetails.patient_id.gender : 'U',
                    email: orderDetails && orderDetails.patient_id ? orderDetails.patient_id.email : '',
                    mobile: orderDetails && orderDetails.patient_id ? orderDetails.patient_id.mobile : '',
                    provider:
                        orderDetails && orderDetails.provider
                            ? orderDetails.provider.first_name + ' ' + orderDetails.provider.last_name
                            : '',
                    providerNPI: orderDetails && orderDetails.provider ? orderDetails.provider.npi : '',
                    providerFirstName: orderDetails && orderDetails.provider ? orderDetails.provider.first_name : '',
                    providerLastName: orderDetails && orderDetails.provider ? orderDetails.provider.last_name : '',
                    facilitySource: orderDetails ? orderDetails.facility_source : '',
                    facilityDetails:
                        orderDetails && orderDetails.facility_id && orderDetails.facility_id._id
                            ? orderDetails.facility_id
                            : {},
                    description: orderDetails && orderDetails.test_info ? orderDetails.test_info.description : '',
                    specimenType: orderDetails && orderDetails.test_info ? orderDetails.test_info.specimenType : '',
                    diagnosisCode:
                        orderDetails && orderDetails.diagnosis_code && orderDetails.diagnosis_code.length
                            ? orderDetails.diagnosis_code
                            : [],
                    requisition: orderDetails && orderDetails.lab_order_id ? orderDetails.lab_order_id : '',
                    externalSampleId: orderDetails?.external_sample_id || '',
                    sample: orderDetails?.test_info?.sample
                        ? isUsingInternalSample() && orderDetails.external_sample_id === orderDetails.test_info.sample
                            ? ''
                            : orderDetails.test_info.sample
                        : '',
                    collectedDate:
                        orderDetails && orderDetails.test_info && orderDetails.test_info.collected
                            ? moment(orderDetails.test_info.collected, 'YYYYMMDDHHmmss').format('MM/DD/YYYY hh:mm:ss A')
                            : '',
                    collectorName:
                        orderDetails && orderDetails.test_info && orderDetails.test_info.collector_name
                            ? orderDetails.test_info.collector_name
                            : '',
                    receivedDate:
                        orderDetails && orderDetails.test_info && orderDetails.test_info.received
                            ? moment(orderDetails.test_info.received, 'YYYYMMDDHHmmss').format('MM/DD/YYYY hh:mm:ss A')
                            : '',
                    result: orderDetails && orderDetails.results ? orderDetails.results.value : '',
                    facilityId: orderDetails.facility_id ? orderDetails.facility_id._id : '',
                    insuranceDetails: orderDetails.patient_insurance_id ? orderDetails.patient_insurance_id : null,
                    symptoms: orderDetails.symptoms && orderDetails.symptoms.length ? orderDetails.symptoms : [],
                    testDetails: orderDetails.test_id,
                    requisitionPDFPath: orderDetails.requisition_pdf_path || '',
                    requisitionPdfPaths: orderDetails.requisition_pdf_paths || [],
                    orderType: orderDetails.order_type || '',
                    medications: orderDetails.medicationIds
                        ? orderDetails.medicationIds.map((med) => med._id || med)
                        : [],
                    originalMedications: orderDetails.medicationIds
                        ? orderDetails.medicationIds.map((med) => med._id || med)
                        : [],
                    orderDetails: orderDetails
                },
                () => {
                    if (showOrderViewPopup) {
                        this.setState({ showOrderViewPopup: true });
                    }
                }
            );
            this.loadDataForModal();
        });
    };

    handleShow = () => {
        if (this.state.orderId !== '') {
            this.loadOrderDetails();
            this.setState({ errors: [], saving: false });
        }
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false, showRevertCancelPopup: false });
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
        if (e.target.name === 'facilityId') {
            const facility = this.state.facilities.filter((fac) => fac._id === e.target.value)[0];
            this.setState({
                facilitySource: facility.name,
                facilityDetails: facility
            });
            this.getPhysicians(e.target.value);
        }
        if (e.target.name === 'selectedProviderId') {
            let index = this.state.providers.findIndex((i) => i._id === e.target.value);
            if (index > -1) {
                this.setState({
                    providerFirstName: this.state.providers[index].first_name,
                    providerLastName: this.state.providers[index].last_name,
                    providerNPI: this.state.providers[index].npi,
                    providerDetails: this.state.providers[index]
                });
            }
        }
        if (e.target.name === 'symptoms') {
            const value = e.target.value;
            let symptoms = this.state.symptoms;
            if (value === 'None') {
                symptoms = ['None'];
            } else {
                if (symptoms.findIndex((element) => element === value) === -1 && e.target.checked) {
                    symptoms.push(value);
                } else if (symptoms.findIndex((element) => element === value) !== -1 && !e.target.checked) {
                    symptoms.splice(
                        symptoms.findIndex((element) => element === value),
                        1
                    );
                }
                symptoms = symptoms.filter((symptom) => symptom !== 'None');
            }
            this.setState({ symptoms: symptoms });
        }
    };

    loadDataForModal = () => {
        if (this.props?.context?.componentParent?.state?.allFacilities) {
            let allFacilities = this.props.context.componentParent.state.allFacilities;
            let filteredFacilities = [];
            allFacilities.map((facility) => {
                if (facility.testIds && facility.testIds.length) {
                    facility.testIds.map((test) => {
                        if (test._id === this.state.testDetails._id) {
                            filteredFacilities.push(facility);
                        }
                        return null;
                    });
                }
                return null;
            });
            this.setState({ facilities: filteredFacilities });
            const facility = filteredFacilities.filter((fac) => fac._id === this.props.data.facility_id._id)[0];
            this.setState({ facilityDetails: facility });
            if (facility && facility._id) {
                this.getPhysicians(facility._id);
            }
        }
    };

    getPhysicians = (facilityId) => {
        fetchPhysicians(facilityId).then((response) => {
            this.setState({
                providers: response.data
            });
            if (response.data.length) {
                const provider = response.data.filter(
                    (provider) => Number(provider.npi) === Number(this.state.providerNPI)
                )[0];
                if (provider) {
                    this.setState({
                        selectedProviderId: provider._id,
                        providerDetails: provider
                    });
                } else {
                    this.setState({
                        selectedProviderId: response.data[0]._id,
                        providerFirstName: response.data[0].first_name,
                        providerLastName: response.data[0].last_name,
                        providerNPI: response.data[0].npi,
                        providerDetails: response.data[0]
                    });
                }
            } else {
                this.setState({
                    selectedProviderId: '',
                    providerFirstName: '',
                    providerLastName: '',
                    providerNPI: '',
                    providerDetails: null
                });
            }
        });
    };

    handleOrderEditChanges = () => {
        let errors = [];
        if (!this.state.collectedDate) {
            errors.push('collectedDate');
        }
        if (
            this.state.collectedDate &&
            moment(this.state.collectedDate, 'MM/DD/YYYY hh:mm:ss A').format('YYYYMMDDHHmmss') === 'Invalid date'
        ) {
            errors.push('wrongCollectedDate');
        }
        // if (!this.state.receivedDate) {
        //     errors.push('receivedDate');
        // }
        // if (
        //     this.state.receivedDate &&
        //     moment(this.state.receivedDate, 'MM/DD/YYYY hh:mm:ss A').format('YYYYMMDDHHmmss') === 'Invalid date'
        // ) {
        //     errors.push('wrongReceivedDate');
        // }
        if (!this.state.sample && !isUsingInternalSample()) {
            errors.push('sample');
        }
        if (errors.length) {
            this.setState({ errors: errors });
        } else {
            this.setState({ showCorrectionInfoPopup: true, errors: [] });
        }
    };

    handleCorrectionSubmit = (correctionInfo) => {
        this.setState({ showCorrectionInfoPopup: false });
        this.performOrderEdit(correctionInfo);
    };

    performOrderEdit = (correctionInfo) => {
        let errors = [];
        if (!this.state.collectedDate) {
            errors.push('collectedDate');
        }
        if (
            this.state.collectedDate &&
            moment(this.state.collectedDate, 'MM/DD/YYYY hh:mm:ss A').format('YYYYMMDDHHmmss') === 'Invalid date'
        ) {
            errors.push('wrongCollectedDate');
        }
        // if (!this.state.receivedDate) {
        //     errors.push('receivedDate');
        // }
        // if (
        //     this.state.receivedDate &&
        //     moment(this.state.receivedDate, 'MM/DD/YYYY hh:mm:ss A').format('YYYYMMDDHHmmss') === 'Invalid date'
        // ) {
        //     errors.push('wrongReceivedDate');
        // }
        if (!this.state.sample && !isUsingInternalSample()) {
            errors.push('sample');
        }
        if (errors.length) {
            this.setState({ errors: errors });
        } else {
            this.setState({ saving: true });
            const editParams = {
                orderId: this.state.orderId,
                description: this.state.description,
                specimenType: this.state.specimenType,
                collectorName: this.state.collectorName,
                diagnosis_code: this.state.diagnosisCode,
                sample: this.state.sample ? this.state.sample : this.state.externalSampleId,
                collectedDate: this.state.collectedDate
                    ? moment(this.state.collectedDate, 'MM/DD/YYYY hh:mm:ss A').format('YYYYMMDDHHmmss')
                    : '',
                provider: this.state.provider,
                receivedDate: this.state.receivedDate
                    ? moment(this.state.receivedDate, 'MM/DD/YYYY hh:mm:ss A').format('YYYYMMDDHHmmss')
                    : '',
                requisition: this.state.requisition,
                patientName: this.state.patientName,
                email: this.state.email,
                mobile: this.state.mobile,
                mrn: this.state.mrn,
                dob: this.state.dob,
                updateRequisition: true,
                facility_id: this.state.facilityId,
                facility_source: this.state.facilitySource,
                providerFirstName: this.state.providerFirstName,
                providerLastName: this.state.providerLastName,
                providerNPI: this.state.providerNPI,
                requisition_pdf_path: this.state.requisitionPDFPath,
                symptoms: this.state.symptoms && this.state.symptoms.length ? this.state.symptoms : [],
                medicationIds: this.state.medications,
                // Add correction info to the request
                correctionInfo: {
                    ...correctionInfo,
                    updated_by: this.userName,
                    updated_at: new Date().toISOString()
                }
            };
            saveOrderEditData(editParams).then((res) => {
                // Update local correction history state
                const newCorrectionEntry = {
                    ...correctionInfo,
                    updated_by: correctionInfo.updated_by,
                    updated_at: correctionInfo.updated_at
                };
                this.setState((prevState) => ({
                    correctionHistory: [...prevState.correctionHistory, newCorrectionEntry]
                }));
                this.savePDF();
                toastr.success('Order updated with correction information');
                if (!arraysEqual(this.state.originalMedications, this.state.medications) && isUsingInternalSample()) {
                    Swal.fire({
                        text: 'Do you want to apply reflux rule based on the medication?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        customClass: {
                            container:
                                window.localStorage.getItem('appTheme') === 'Dark' &&
                                /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                                'dark-swal',
                            cancelButton: 'order-1',
                            confirmButton: 'order-2'
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            checkMedicationReflux({
                                order: { _id: this.state.orderId, medicationIds: this.state.medications }
                            }).then((res) => {});
                        }
                    });
                }
            });
        }
    };

    savePDF = () => {
        this.setState({ savingPDF: true });
        let pdfParams = {
            orderId: this.state.orderId
        };
        createRequisitionPDF(pdfParams).then((res) => {
            this.handleClose();
            if (
                this.props.context &&
                this.props.context.componentParent &&
                !(this.props.type && this.props.type === 'patientViewPopup')
            ) {
                this.props.context.componentParent.loadGridData();
            }
        });

        generateResultPDF({ orderId: this.state.orderId });
    };

    handleRevert = () => {
        const revertCancelData = {
            _id: this.props.data._id
        };
        revertCancelRequisition(revertCancelData).then((respond) => {
            this.handleClose();
            if (
                this.props.context &&
                this.props.context.componentParent &&
                this.props.context.componentParent.loadGridData
            ) {
                this.props.context.componentParent.loadGridData();
            } else {
                this.props.context.componentParent.props.handleClose();
            }
        });
    };

    handleMarkPreliminary = () => {
        Swal.fire({
            title: 'Mark as Preliminary',
            text: 'This will release a PRELIMINARY (watermarked) report. A lab director must approve it before it becomes Final. Continue?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, Mark Preliminary',
            cancelButtonText: 'Cancel',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                markPreliminary({ orderId: this.state.orderId }).then((res) => {
                    if (res && res.status === 200) {
                        toastr.success('Report marked Preliminary');
                        if (this.props.context && this.props.context.componentParent && this.props.context.componentParent.loadGridData) {
                            this.props.context.componentParent.loadGridData();
                        }
                    } else {
                        toastr.error(res?.message || 'Error marking report preliminary');
                    }
                }).catch(() => toastr.error('Error marking report preliminary'));
            }
        });
    };

    handleApproveReport = () => {
        Swal.fire({
            title: 'Approve Report',
            text: 'This will finalize the report and regenerate the PDF without watermark. Continue?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, Approve',
            cancelButtonText: 'Cancel',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                approveReport({ orderId: this.state.orderId }).then((res) => {
                    if (res && res.status === 200) {
                        toastr.success('Report approved successfully');
                        if (
                            this.props.context &&
                            this.props.context.componentParent &&
                            this.props.context.componentParent.loadGridData
                        ) {
                            this.props.context.componentParent.loadGridData();
                        }
                    } else {
                        const msg = (res && res.message) || '';
                        if (msg.includes('CRITICAL_CALLBACK_REQUIRED')) {
                            Swal.fire({ icon: 'warning', title: 'Critical value callback required',
                                text: 'This order has critical result(s). Log who was called at the facility and when before approving to Final.' });
                        } else {
                            toastr.error(msg || 'Error approving report');
                        }
                    }
                }).catch((err) => {
                    toastr.error('Error approving report');
                });
            }
        });
    };

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit Requisition
        </Tooltip>
    );

    renderTooltipRevertCancel = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Revert Cancellation
        </Tooltip>
    );

    renderTooltipResetAccessioning = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Reset sample for accessioning
        </Tooltip>
    );

    renderAddTestToRequisition = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Add test to requisition
        </Tooltip>
    );

    renderTooltipView = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            View
        </Tooltip>
    );

    renderTooltipUploads = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Upload Files
        </Tooltip>
    );

    handleShowRevertCancelPopup = () => {
        this.setState({ showRevertCancelPopup: true });
    };

    handleResetAccessioning = () => {
        Swal.fire({
            title: 'Revert Accession Status',
            text:
                'This will make accessioned status to false so sample ' +
                this.props.data.test_info.sample.toString() +
                ' can be plated again.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const data = {
                    _id: this.state.orderId,
                    is_assigned_to_plate: false
                };
                orderEasyUpdate(data).then((res) => {
                    if (
                        this.props.context &&
                        this.props.context.componentParent &&
                        this.props.context.componentParent.loadGridData
                    ) {
                        this.props.context.componentParent.loadGridData();
                    } else {
                        this.props.context.componentParent.props.handleClose();
                    }
                    toastr.success('Successfully reset');
                });
            }
        });
    };

    handlePreviewReport = () => {
        const reqNo = this.props.data.lab_order_id;
        if (!reqNo) { toastr.error('No requisition number on this order'); return; }
        toastr.info('Generating report preview...');
        previewReport({ lab_order_id: reqNo }).then((res) => {
            if (res && res.success) window.open(`${serviceConstants.API_HOST_NAME}/files/resultPDF/${res.data.pdf_path}?${Date.now()}&token=${getUserAuthToken()}`, '_blank');
            else toastr.error((res && res.message) || 'Preview failed');
        }).catch(() => toastr.error('Preview failed'));
    };
    rptHasCritical = () => ((this.props.data.results && this.props.data.results.values) || []).some((v) => v && (v.is_critical_high || v.is_critical_low));
    rptCallbacks = () => this.state.callbackComments || this.props.data.callback_comments || [];
    rptCorrections = () => this.state.correctionHistory || this.props.data.correction_history || [];
    handleToxCallbackSubmit = (callbackEntry) => {
        addCallbackComment({ orderId: this.state.orderId || this.props.data._id, callbackEntry })
            .then((res) => {
                const updated = res && res.data && res.data.callback_comments;
                this.setState({ callbackComments: updated || [...this.rptCallbacks(), callbackEntry] });
                toastr.success('Critical value callback logged');
                if (this.props.context && this.props.context.componentParent && this.props.context.componentParent.loadGridData) this.props.context.componentParent.loadGridData();
            })
            .catch(() => toastr.error('Failed to save callback log'));
    };
    handleToxCorrectionSubmit = (correctionInfo) => {
        addCorrection({ orderId: this.state.orderId || this.props.data._id, correctionInfo })
            .then((res) => {
                const updated = res && res.data;
                this.setState({ showRptCorrectionPopup: false, correctionHistory: (updated && updated.correction_history) || this.rptCorrections() });
                toastr.success(`${correctionInfo.correctionType === 'amended' ? 'Amendment' : 'Correction'} logged successfully`);
                if (this.props.context && this.props.context.componentParent && this.props.context.componentParent.loadGridData) this.props.context.componentParent.loadGridData();
            })
            .catch(() => toastr.error('Failed to save correction'));
    };

    render() {
        const medicationOptions = this.props.context.componentParent.state?.medicationOptions || [];
        return (
            <div className="d-flex align-items-center">
                {!(this.props.data.order_type && this.props.data.order_type === 'sub_panel') && (
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                        <button onClick={this.handleShow} className="edit-order-btn position-relative">
                            <i className="fas fa-pen"></i>
                        </button>
                    </OverlayTrigger>
                )}
                {this.state.correctionHistory && this.state.correctionHistory.length > 0 && (
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 50, hide: 100 }}
                        overlay={(props) => (
                            <Tooltip id="button-tooltip" {...props}>
                                View Correction History ({this.state.correctionHistory.length})
                            </Tooltip>
                        )}
                    >
                        <button
                            onClick={() => this.setState({ showCorrectionHistoryPopup: true })}
                            className="edit-order-btn"
                        >
                            <i className="fas fa-history"></i>
                        </button>
                    </OverlayTrigger>
                )}
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 50, hide: 100 }}
                    overlay={(props) => {
                        return (
                            <Tooltip id="button-tooltip" {...props}>
                                Update Status
                            </Tooltip>
                        );
                    }}
                >
                    <button
                        onClick={() => {
                            this.setState({ showStatusPopup: true });
                        }}
                        className="edit-order-btn"
                    >
                        <i className="fas fa-tasks"></i>
                    </button>
                </OverlayTrigger>
                {this.props.data.is_cancel &&
                    !(
                        this.props.data.parent_id &&
                        this.props.data.parent_id.results &&
                        this.props.data.parent_id.results.value &&
                        this.props.data.parent_id.results.value.includes(' - Full Results')
                    ) && (
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 50, hide: 100 }}
                            overlay={this.renderTooltipRevertCancel}
                        >
                            <button onClick={this.handleShowRevertCancelPopup} className="edit-order-btn">
                                <i className="fas fa-envelope"></i>
                            </button>
                        </OverlayTrigger>
                    )}

                {this.props.data.sample_tracking.filter((item) => item.eventName === 'ACCESSIONED').length > 0 &&
                    this.props.data.is_assigned_to_plate &&
                    !(this.props.data.results && this.props.data.results.value) && (
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 50, hide: 100 }}
                            overlay={this.renderTooltipResetAccessioning}
                        >
                            <button onClick={this.handleResetAccessioning} className="edit-order-btn">
                                <i className="fas fa-rotate-left"></i>
                            </button>
                        </OverlayTrigger>
                    )}
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 50, hide: 100 }}
                    overlay={this.renderAddTestToRequisition}
                >
                    <button
                        onClick={() =>
                            this.setState({
                                showAddTestToRequisitionPopup: true
                            })
                        }
                        className="edit-order-btn"
                    >
                        <i className="fas fa-plus"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipView}>
                    <button
                        onClick={() => {
                            this.loadOrderDetails(true);
                        }}
                        className="edit-order-btn"
                    >
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipUploads}>
                    <button onClick={() => { console.log("clicked"); this.setState({ isModalOpen: !this.state.isModalOpen }); }} className="edit-order-btn">
                        <i className="fas fa-file-upload"></i>
                    </button>
                </OverlayTrigger>
                {['Pending Review', 'Resulted'].includes(this.props.data.status) && (
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 50, hide: 100 }}
                        overlay={<Tooltip id="button-tooltip">Release</Tooltip>}
                    >
                        <button
                            onClick={() => {
                                if (this.props.data.status !== 'Resulted') {
                                    this.props.context.componentParent.releaseSelectedItems([this.props.data._id]);
                                }
                            }}
                            className="edit-order-btn"
                            disabled={this.props.data.status === 'Resulted'}
                            style={{ opacity: this.props.data.status === 'Resulted' ? 0.5 : 1, cursor: this.props.data.status === 'Released' ? 'not-allowed' : 'pointer' }}
                        >
                            <i className="fas fa-arrow-circle-right"></i>
                        </button>
                    </OverlayTrigger>
                )}
                {['Resulted', 'Pending Review', 'Reviewed', 'Reported'].includes(this.props.data.status) && (
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">{this.props.data.tox_interpretation
                        ? `Tox Review applied ${new Date(this.props.data.tox_interpretation.applied_at).toLocaleDateString()} by ${this.props.data.tox_interpretation.applied_by} — ${this.props.data.tox_interpretation.inconsistent || 0} inconsistent`
                        : 'Tox Review (not yet applied)'}</Tooltip>}>
                        <button onClick={() => this.setState({ showToxReview: true })} className="edit-order-btn">
                            <i className="fas fa-flask" style={{ color: this.props.data.tox_interpretation ? (this.props.data.tox_interpretation.inconsistent > 0 ? '#dc3545' : '#198754') : '#6f42c1' }}></i>
                        </button>
                    </OverlayTrigger>
                )}
                {this.state.showToxReview && (
                    <ToxReviewPopup orderId={this.state.orderId || this.props.data._id} onClose={() => this.setState({ showToxReview: false })} onApplied={() => { if (this.props.context && this.props.context.componentParent && this.props.context.componentParent.loadGridData) this.props.context.componentParent.loadGridData(); }} />
                )}
                {!['preliminary', 'final'].includes(this.props.data.report_status) &&
                    ['Resulted', 'Pending Review', 'Reviewed'].includes(this.props.data.status) &&
                    ['SuperAdmin', 'Admin'].includes(getUserRole()) && (
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 50, hide: 100 }}
                        overlay={<Tooltip id="button-tooltip">Mark Preliminary</Tooltip>}
                    >
                        <button
                            onClick={this.handleMarkPreliminary}
                            className="edit-order-btn"
                            style={{ color: '#fd7e14' }}
                        >
                            <i className="fas fa-hourglass-half"></i>
                        </button>
                    </OverlayTrigger>
                )}
                {this.props.data.report_status === 'preliminary' &&
                    ['SuperAdmin', 'Admin'].includes(getUserRole()) && (
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 50, hide: 100 }}
                        overlay={<Tooltip id="button-tooltip">Approve Report</Tooltip>}
                    >
                        <button
                            onClick={this.handleApproveReport}
                            className="edit-order-btn"
                            style={{ color: '#28a745' }}
                        >
                            <i className="fas fa-check-circle"></i>
                        </button>
                    </OverlayTrigger>
                )}
                {['SuperAdmin', 'Admin'].includes(getUserRole()) && (
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">Preview Report</Tooltip>}>
                        <button onClick={this.handlePreviewReport} className="edit-order-btn"><i className="fas fa-file-medical" style={{ color: '#d63384' }}></i></button>
                    </OverlayTrigger>
                )}
                {['SuperAdmin', 'Admin'].includes(getUserRole()) && (this.rptHasCritical() || this.props.data.report_status === 'preliminary') && (
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">{this.rptCallbacks().length ? `Critical callback logged (${this.rptCallbacks().length})` : 'Log Critical Value Callback'}</Tooltip>}>
                        <button onClick={() => this.setState({ showCallbackPopup: true })} className="edit-order-btn"><i className="fas fa-phone" style={{ color: '#e0a800' }}></i></button>
                    </OverlayTrigger>
                )}
                {['SuperAdmin', 'Admin'].includes(getUserRole()) && ['final', 'corrected', 'amended'].includes(this.props.data.report_status) && (
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">Correction / Amendment</Tooltip>}>
                        <button onClick={() => this.setState({ showRptCorrectionPopup: true })} className="edit-order-btn"><i className="fas fa-file-signature" style={{ color: '#0d6efd' }}></i></button>
                    </OverlayTrigger>
                )}
                {this.state.showRptCorrectionPopup && (
                    <CorrectionInfoPopup show={true} onClose={() => this.setState({ showRptCorrectionPopup: false })} onSubmit={this.handleToxCorrectionSubmit} userName={getUserFullName()} />
                )}
                {this.state.showCallbackPopup && (
                    <CallbackCommentPopup show={true} onClose={() => this.setState({ showCallbackPopup: false })} onSubmit={this.handleToxCallbackSubmit} callbackComments={this.rptCallbacks()} orderId={this.state.orderId || this.props.data._id} />
                )}

                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row form-row">
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label>Patient Name</label>
                                    <input
                                        type="text"
                                        disabled
                                        className="form-control"
                                        name="patientName"
                                        value={this.state.patientName}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                            <div className={'col-12 col-md-' + (isUsingInternalSample() ? '6' : '3')}>
                                <div className="form-group">
                                    <label>MRN</label>
                                    <input
                                        type="text"
                                        disabled
                                        className="form-control"
                                        name="mrn"
                                        value={this.state.mrn}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                            <div className={'col-12 col-md-' + (isUsingInternalSample() ? '6' : '3')}>
                                <div className="form-group">
                                    <label>Gender</label>
                                    <input
                                        type="text"
                                        disabled
                                        className="form-control"
                                        name="gender"
                                        value={this.state.gender}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label>Date Of Birth</label>
                                    <input
                                        type="text"
                                        disabled
                                        className="form-control"
                                        name="dob"
                                        value={this.state.dob}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label>Facility</label>
                                    <select
                                        required
                                        type="text"
                                        name="facilityId"
                                        value={this.state.facilityId}
                                        onChange={this.handleChange}
                                        className="form-control"
                                        disabled
                                    >
                                        {this.state.facilities &&
                                            this.state.facilities.map((fac) => {
                                                return (
                                                    <option value={fac._id} key={fac._id}>
                                                        {fac.name} {fac.archived === 'archived' ? ' ( Archived ) ' : ''}
                                                    </option>
                                                );
                                            })}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label>Physician</label>
                                    <select
                                        required
                                        type="text"
                                        name="selectedProviderId"
                                        value={this.state.selectedProviderId}
                                        onChange={this.handleChange}
                                        className="form-control"
                                    >
                                        {this.state.providers &&
                                            this.state.providers.map((prov) => {
                                                return (
                                                    <option value={prov._id} key={prov._id}>
                                                        {prov.first_name + ' ' + prov.last_name}
                                                    </option>
                                                );
                                            })}
                                    </select>
                                </div>
                            </div>
                            {this.state.orderType !== 'root' && (
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <label>Test Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            disabled
                                            value={this.state.testDetails.name}
                                        />
                                    </div>
                                </div>
                            )}
                            {this.state.orderType !== 'root' && (
                                <div className="col-12">
                                    <div className="form-group">
                                        <label>Specimen Type</label>
                                        <input
                                            className="form-control"
                                            name="specimenType"
                                            value={this.state.specimenType}
                                            disabled
                                        />
                                        <div
                                            className={this.hasError('specimenType') ? 'inline-errormsg' : 'hidden'}
                                            style={{
                                                width: 'auto',
                                                fontSize: '15px'
                                            }}
                                        >
                                            <i className="fa fa-exclamation-circle" aria-hidden="true">
                                                &nbsp;This field is required
                                            </i>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {isUsingInternalSample() && (
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <label>External Order</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="sample"
                                            value={this.state.externalSampleId}
                                            disabled
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label>Sample</label>
                                    <div className="position-relative">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="sample"
                                            style={{ paddingRight: '30px' }}
                                            value={this.state.sample}
                                            onChange={this.handleChange}
                                        />
                                        <div className="position-absolute" style={{ top: '4px', right: '4px' }}>
                                            <OverlayTrigger
                                                placement="top"
                                                delay={{ show: 50, hide: 100 }}
                                                overlay={<Tooltip id="button-tooltip">Auto Generate Sample</Tooltip>}
                                            >
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={(e) => {
                                                        generateUniqueKey().then((res) => {
                                                            this.setState({ sample: res.data });
                                                        });
                                                        e.stopPropagation();
                                                    }}
                                                >
                                                    <i className="fa fa-magic" aria-hidden="true"></i>
                                                </button>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                    <div
                                        className={this.hasError('sample') ? 'inline-errormsg' : 'hidden'}
                                        style={{
                                            width: 'auto',
                                            fontSize: '15px'
                                        }}
                                    >
                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                            &nbsp;This field is required
                                        </i>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label>Collected Date</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="collectedDate"
                                        value={this.state.collectedDate}
                                        onChange={this.handleChange}
                                    />
                                    <label style={{ fontSize: '13px' }}>Date format - MM/DD/YYYY hh:mi:ss AM/PM</label>
                                    <div
                                        className={this.hasError('collectedDate') ? 'inline-errormsg' : 'hidden'}
                                        style={{
                                            width: 'auto',
                                            fontSize: '15px'
                                        }}
                                    >
                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                            &nbsp;This field is required
                                        </i>
                                    </div>
                                    <div
                                        className={this.hasError('wrongCollectedDate') ? 'inline-errormsg' : 'hidden'}
                                        style={{
                                            width: 'auto',
                                            fontSize: '15px'
                                        }}
                                    >
                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                            &nbsp;Please provide correctly
                                        </i>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <FormControl>
                                            <FormLabel>
                                                Symptoms <abbr className="text-danger">*</abbr>
                                            </FormLabel>
                                            {this.state.testDetails &&
                                                this.state.testDetails.symptoms &&
                                                this.state.testDetails.symptoms.map((item, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <Checkbox
                                                                checked={
                                                                    this.state.symptoms &&
                                                                    this.state.symptoms.findIndex(
                                                                        (elem) => elem === item
                                                                    ) !== -1
                                                                }
                                                                onChange={this.handleChange}
                                                                value={item}
                                                                name="symptoms"
                                                            />
                                                            <span>{item}</span>
                                                        </div>
                                                    );
                                                })}
                                        </FormControl>
                                    </div>
                                </div> */}
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label>Received Date</label>
                                    <div className="d-flex position-relative">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="receivedDate"
                                            value={this.state.receivedDate}
                                            onChange={this.handleChange}
                                        />
                                        <div className="position-absolute" style={{ top: '4px', right: '4px' }}>
                                            <OverlayTrigger
                                                placement="top"
                                                delay={{ show: 50, hide: 100 }}
                                                overlay={<Tooltip id="button-tooltip">Set current time</Tooltip>}
                                            >
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={(e) => {
                                                        this.setState({
                                                            receivedDate: moment().format('MM/DD/YYYY hh:mm:ss A')
                                                        });
                                                    }}
                                                >
                                                    <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                </button>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                    <label style={{ fontSize: '13px' }}>Date format - MM/DD/YYYY hh:mi:ss AM/PM</label>
                                    <div
                                        className={this.hasError('receivedDate') ? 'inline-errormsg' : 'hidden'}
                                        style={{
                                            width: 'auto',
                                            fontSize: '15px'
                                        }}
                                    >
                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                            &nbsp;This field is required
                                        </i>
                                    </div>
                                    <div
                                        className={this.hasError('wrongCollectedDate') ? 'inline-errormsg' : 'hidden'}
                                        style={{
                                            width: 'auto',
                                            fontSize: '15px'
                                        }}
                                    >
                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                            &nbsp;Please provide correctly
                                        </i>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <Autocomplete
                                        multiple
                                        disableCloseOnSelect
                                        options={this.props.context.componentParent.state?.allDiagnosisCodes || []}
                                        value={
                                            this.state.diagnosisCode
                                                .map((code) =>
                                                    (
                                                        this.props.context.componentParent.state?.allDiagnosisCodes ||
                                                        []
                                                    ).find((item) => code.includes(item.code))
                                                )
                                                .filter(Boolean) || []
                                        }
                                        onChange={(event, newValue) => {
                                            const diagnosisCodes = newValue.map((item) => item.description);
                                            this.setState({ diagnosisCode: diagnosisCodes });
                                        }}
                                        getOptionLabel={(option) => (option ? option.description : '')}
                                        isOptionEqualToValue={(option, value) => option.description === value}
                                        filterOptions={(options, state) => {
                                            const inputValue = state.inputValue.toLowerCase().trim();
                                            if (inputValue.length < 2) return [];
                                            const filtered = options.filter(
                                                (option) =>
                                                    option.code.toLowerCase().includes(inputValue) ||
                                                    option.description.toLowerCase().includes(inputValue)
                                            );
                                            return filtered.slice(0, 100);
                                        }}
                                        renderOption={(props, option, { selected }) => (
                                            <Box component="li" {...props}>
                                                <Checkbox style={{ marginRight: 8 }} checked={selected} />
                                                {option.description}
                                            </Box>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                label="Diagnosis Code For Visit"
                                                placeholder="Type to search diagnosis codes"
                                                helperText="Type at least 2 characters to search. You can select multiple codes."
                                            />
                                        )}
                                    />
                                    <div
                                        className={this.hasError('diagnosisCode') ? 'inline-errormsg' : 'hidden'}
                                        style={{
                                            width: 'auto',
                                            fontSize: '15px'
                                        }}
                                    >
                                        <i className="fa fa-exclamation-circle" aria-hidden="true">
                                            &nbsp;This field is required
                                        </i>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <Autocomplete
                                        multiple
                                        id="medications-autocomplete"
                                        options={medicationOptions}
                                        getOptionLabel={(option) => option.name || ''}
                                        value={medicationOptions.filter((med) =>
                                            this.state.medications.includes(med._id)
                                        )}
                                        onChange={(event, newValue) => {
                                            this.setState({
                                                medications: newValue.map((med) => med._id)
                                            });
                                        }}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Chip
                                                    variant="outlined"
                                                    label={option.name}
                                                    {...getTagProps({ index })}
                                                    key={option._id}
                                                />
                                            ))
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Medications"
                                                placeholder="Select medications"
                                                helperText="Select patient medications for toxicology analysis"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Close
                        </Button>
                        <Button
                            variant="info"
                            onClick={() => {
                                Swal.fire({
                                    title: 'Are you sure?',
                                    text: 'This will update PDF files only, you will lose changes if you have made',
                                    icon: 'info',
                                    showCancelButton: true,
                                    confirmButtonText: 'Yes',
                                    cancelButtonText: 'No',
                                    customClass: {
                                        container:
                                            window.localStorage.getItem('appTheme') === 'Dark' &&
                                            /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                                            'dark-swal',
                                        cancelButton: 'order-1',
                                        confirmButton: 'order-2'
                                    }
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        this.savePDF();
                                    }
                                });
                            }}
                        >
                            {this.state.savingPDF && (
                                <i className="fa fa-refresh fa-spin" style={{ marginRight: '5px' }}></i>
                            )}
                            Save PDF
                        </Button>
                        <Button variant="primary" onClick={this.handleOrderEditChanges}>
                            {this.state.saving && (
                                <i className="fa fa-refresh fa-spin" style={{ marginRight: '5px' }}></i>
                            )}
                            Save Changes for correction
                        </Button>
                    </Modal.Footer>
                </ModalStyled>

                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.showRevertCancelPopup}
                    onHide={this.handleClose}
                    onEnter={this.loadDataForModal}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Revert Cancellation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form>
                            <div className="row form-row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label>Facility</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={this.state.facilitySource}
                                            disabled
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>
                                            The cancellation of the requisition is reverted and the email is sent to the
                                            facility.
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={this.handleRevert}>
                            Revert & Email Facillity
                        </Button>
                    </Modal.Footer>
                </ModalStyled>
                <OrderViewPopup
                    show={this.state.showOrderViewPopup}
                    handleClose={() => this.setState({ showOrderViewPopup: false })}
                    onOpenSidePanel={() => this.setState({ showDrawer: true })}
                    data={this.props.data}
                    context={this.props.context}
                    type="requisition"
                    orderDetails={this.state.orderDetails}
                    requisitionPdfPaths={this.state.requisitionPdfPaths}
                />
                {this.state.showDrawer && (
                    <SubOrderDrawer
                        orderDetails={this.state.orderDetails || this.props.data}
                        onClose={() => this.setState({ showDrawer: false })}
                    />
                )}
                <OrderStatusPopup
                    show={this.state.showStatusPopup}
                    handleClose={() => this.setState({ showStatusPopup: false })}
                    data={this.props.data}
                    context={this.props.context}
                />
                <AddTestToRequisition
                    show={this.state.showAddTestToRequisitionPopup}
                    hideCreateRequisitionHandler={() => {
                        this.setState({ showAddTestToRequisitionPopup: false });
                    }}
                    patientDetails={this.state.patientDetails || {}}
                    orderDetails={this.state.orderDetails}
                    context={this.props.context}
                    rootOrderId={this.state.orderId}
                    requisitionPDFPath={this.state.requisitionPDFPath}
                />
                <CorrectionInfoPopup
                    show={this.state.showCorrectionInfoPopup}
                    onClose={() => this.setState({ showCorrectionInfoPopup: false })}
                    onSubmit={this.handleCorrectionSubmit}
                    userName={this.userName}
                />
                <CorrectionHistoryPopup
                    show={this.state.showCorrectionHistoryPopup}
                    onClose={() => this.setState({ showCorrectionHistoryPopup: false })}
                    correctionHistory={this.state.correctionHistory}
                />
                                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.isModalOpen}
                    onHide={() => this.setState({ isModalOpen: false })}
                    backdrop="static"                    
                >   
                <Modal.Header closeButton>
                    <Modal.Title>Upload Requisition Files</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <UploadFileModel
                        isOpen={this.state.isModalOpen}
                        onClose={() => this.setState({ isModalOpen: false })}
                        requisitionNo={this.state.requisition}                                                                          
                        setRequisitionPdfPaths={(paths) => { console.log("called"); this.setState({ requisitionPdfPaths: paths })}}
                        Orderdetails={this.props.data}
                      />
                    </Modal.Body>
                </ModalStyled>  
            </div>
        );
    }
}
